module.exports = __webpack_public_path__ + "static/media/r.89574ff1.svg";